import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "@/styles/global.css";
import "@/styles/app-shell.css";
import { router } from "@/routes/router";
import { SessionProvider } from "@/contexts/SessionContext";
import { ToastProvider } from "@/contexts/ToastContext";
import { PreferencesProvider } from "@/contexts/PreferencesContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";

async function enableMocks(): Promise<void> {
  if (!import.meta.env.DEV) return;
  const { worker } = await import("@/mocks/browser");
  await worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: { url: "/mockServiceWorker.js" },
    quiet: true,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});

void enableMocks().then(() => {
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("#root not found");
  createRoot(rootEl).render(
    <StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <SessionProvider>
              <PreferencesProvider>
                <RouterProvider router={router} />
              </PreferencesProvider>
            </SessionProvider>
          </ToastProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </StrictMode>,
  );
});
